import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const reopenPeriod = async (periodId) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.patch(`/current-organization/course-assignment/periods/${periodId}/reopen`)
  return data
}

export const useReopenPeriod = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: reopenPeriod,
    hookName: 'useReopenPeriod',
    errorMessage: 'Error reopening course assignment period',
    // A 409 means another period of the same grade is already open - an expected state the
    // history screen already guards against and explains, not a bug worth reporting.
    shouldReportError: (error) => error?.response?.status !== 409,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriodStatus'] })
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriods'] })
    }
  })
}
